export { fromLegacyPlacement } from '../placement-map';
export { LEGACY_PLACEMENTS } from '../placement-map/legacy-placements';
export type { TLegacyPlacement, TPlacementOptions } from '../placement-map';
